import { Page } from '@/components';
import TokensBaseTable from './tokens_base_table';
export default function BaseTokenPage() {
  return (
    <Page title="Tokens">
      <TokensBaseTable />
    </Page>
  );
}
